module.exports = __webpack_public_path__ + "static/media/OutlineBookMark.cecbb965.svg";